import React, { useState,useContext } from 'react';
import { AuthContext } from './auth/auth';
import { Link, useHistory } from 'react-router-dom';
import '../style/navbar.css';
import logo from "../assets/logo.png"
import app from '../firebase/base';
 
const Navbar = () => {
 
  const { currentUser } = useContext(AuthContext);
 


  return (
    <div className="scanEL__navbar">
      <div className="scanEL__navbar-links">
        <a href='/'>
        <div >
         <img className='ScannelLogo' src={logo}></img>
        </div></a>
     
      </div>
      
      <div className="scanEL__navbar-sign"> 
   
        {currentUser 
          ? (<button onClick={() => {app.auth().signOut(); useHistory= "/";}}>Logout</button>) 
          : (<div className='auth_buttons'>
   
           <a href='/login'><button className='singin_btn' >Sign In </button></a>
           <a href='/signup'><button >Sign up</button></a>
           </div>
         )}
         </div>
    
    </div>
  );
};

export default Navbar;
